import React, { useCallback, useState } from "react";
import useApi from "./useApi";

export default function useVersion() {
  const api = useApi();
  const [version, setVersion] = useState<string | null>(null);
  const [deployedAt, setDeployedAt] = useState<string | null>(null);
  const [showReloadModal, setShowReloadModal] = useState(false);

  function resetModal() {
    setShowReloadModal(false);
  }
  const getVersion = useCallback(async () => {
    try {
      // Prefer the admin API's own /version — that's what actually deployed for this UI.
      // Messaging API is a separate service with a separate deploy cadence. Falling back
      // to it is only useful if the admin endpoint isn't reachable (shouldn't happen on
      // the happy path but keeps the hook robust during a rolling deploy).
      let response = await api.admin.get("version");
      if (!response.ok) {
        response = await api.messaging.get("version");
        if (!response.ok) return;
      }
      const data = await response.json();
      // Support both old string shape and new { version, deployedAt } shape
      const newVersion = typeof data === "string" ? data : data?.version;
      if (typeof data !== "string" && data?.deployedAt) {
        setDeployedAt(data.deployedAt);
      }
      if (version == null) {
        setVersion(newVersion);
      } else if (version != newVersion) {
        setShowReloadModal(true);
      }
    } catch {
      // Network error (API down) — swallow silently, retry on next interval
    }
  }, [api.admin, api.messaging, version]);

  React.useEffect(() => {
    if (version == null) {
      getVersion();
    }
    //periodically ping the server to check for a new version
    const interval = setInterval(getVersion, 1000 * 30);
    return () => clearInterval(interval);
  }, [api.messaging, getVersion, version]);

  return { showReloadModal, resetModal, version, deployedAt };
}
